import React from 'react';
import { useDispatch, connect } from 'react-redux';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import PropTypes from 'prop-types';
import dialogActions from 'core/dialogs/actions';
import Button from 'common/Button';
import pageActions from 'core/page/actions';
import dialogStyles from './styles/dialog';
import contentWrapperStyles from './styles/contentWrapper';
import contentStyles from './styles/content';
import headerStyles from './styles/header';
import titleStyles from './styles/title';
import bodyStyles from './styles/body';
import footerStyles from './styles/footer';

const styles = (theme) => {
  const common = {
    body: bodyStyles(theme),
    content: contentStyles(theme),
    contentWrapper: contentWrapperStyles(theme),
    dialog: dialogStyles(theme),
    footer: {
      ...footerStyles(theme),
      '& button': {
        border: 'none',
      },
      boxShadow: 'none',
    },
    header: headerStyles(theme),
    title: titleStyles(theme),
  };
  return common;
};

const Remove = ({
  appId,
  cancelButtonLabel,
  classes,
  close,
  commonClasses,
  confirmButtonLabel,
  message,
  title,
}) => {
  const dispatch = useDispatch();
  const removeProduct = () => dispatch(pageActions.removeProduct(appId));

  return (
    <div className={classnames('dialog-remove', commonClasses, classes.dialog)}>
      <form className={classnames('modal-content', classes.content)}>
        <div className={classnames('modal-header', classes.header)}>
          <h4 className={classnames('modal-title', classes.title)} id="modal-title">
            {title}
          </h4>
        </div>
        <div className={classnames('modal-body', classes.body)} id="modal-body">
          <div className={classnames('modal-content-wrapper', classes.contentWrapper)}>
            <p>{message}</p>
          </div>
        </div>
        <div className={classnames('modal-footer', classes.footer)}>
          <Button className="btn btn-primary popbox-btn0" data-key="0" onClick={removeProduct}>
            {confirmButtonLabel}
          </Button>
          <Button
            className="btn btn-tertiary popbox-btn1"
            variant="secondary"
            data-key="1"
            onClick={close}
          >
            {cancelButtonLabel}
          </Button>
        </div>
      </form>
    </div>
  );
};

Remove.propTypes = {
  appId: PropTypes.string.isRequired,
  cancelButtonLabel: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  close: PropTypes.func.isRequired,
  commonClasses: PropTypes.string.isRequired,
  confirmButtonLabel: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const mapStateToProps = ({ dialogs }) => ({
  appId: dialogs.params.appId,
  cancelButtonLabel: dialogs.params.cancelButtonLabel,
  confirmButtonLabel: dialogs.params.confirmButtonLabel,
  message: dialogs.params.message,
  title: dialogs.params.title,
});

const RemoveStyled = withStyles(styles)(Remove);

export default connect(mapStateToProps, { close: dialogActions.close })(RemoveStyled);
